module.exports = __webpack_public_path__ + "img/brand-models-slider.8065629d.png";